// removed by extract-text-webpack-plugin
module.exports = {"take-action-share":"take-action-share___1vRDX center___2iqBf","take-action-label":"take-action-label___Cypmd","take-action-blockquote":"take-action-blockquote___3MIDP h4___kHWTn","take-action-icons":"take-action-icons___21kBY center___2iqBf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PetitionRotatingTweet/PetitionRotatingTweet.css
// module id = 895
// module chunks = 0